<template>
    <div class="slideshow-item" v-if="data">
        <swiper :options="swiper_options" ref="swiper">
            <swiper-slide v-for="(item, index) in data" :key="index">
                <img :src="item.large" @click="nextSide" />
            </swiper-slide>
            <div class="prev js-prev" slot="button-prev"></div>
            <div class="next js-next" slot="button-next"></div>
        </swiper>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';


export default {
    name: 'slideshow-item',

    data() {
        return {
            swiper_options: {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.js-next',
                    prevEl: '.js-prev',
                },
                autoHeight: true,



            },
        }
    },

    components: {
        Swiper,
        SwiperSlide,
    },



    props: {
        data: Array,
    },



    methods: {
        nextSide() {
            this.$refs.swiper.$swiper.slideNext();
        },
 

    },


    // mounted() {
    //     this.data.forEach(item => {
    //         if (item.type === 'video') item.is_playing = false;
    //     });
    // },
}
</script>

<style lang="scss">
    .slideshow-item {
        width: 100%;
        position: relative;

        .prev,
        .next {
            position: absolute;
            cursor: pointer;
            width: 50%;
            z-index: 99;
            top: 0;
            height: 100%;

            &:hover,
            &:focus {
                outline: none;
            }
        }

        .next {
            right: 0;
        }

        .prev {
            left: 0;
        }

        .swiper-container,
        .swiper-wrapper,
        .swiper-slide,
        .swiper-slide {
            width: 100%;
        }

        .swiper-slide {
            transform: translateZ(0);
        }







        img {
            display: block;
            height: auto;
            width: 100%;
        }

        
    }

</style>
